import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useWebSocket } from 'context/WebSocketContext';
import React from 'react'
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { mfaVerification } from 'services/apiAuth1';

const useMfaVerification = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();
    const {connectWebSocket} = useWebSocket();

    const{isPending,mutate: verify}=useMutation({
        mutationFn:(data)=> mfaVerification(data),
        onSuccess:(data)=>{
            localStorage.setItem("userData",JSON.stringify(data))
            localStorage.setItem("accessToken",JSON.stringify(data.access))
            localStorage.setItem("refreshToken",JSON.stringify(data.refresh))
            connectWebSocket(data.access)
            queryClient.setQueryData(["userData"],data)
            toast.success("Verification Successful")
            navigate('/dashboard',{replace:true})
        },
        onError:(error)=>{
            console.log("Verification error:", error);

            if (error?.status === 400 || error?.status === 404) {
                const message = error?.data?.message ?? "Session expired. Please log in again.";
                toast.error(message)

                queryClient.removeQueries({ queryKey: ["mfa-session"] })
                localStorage.removeItem('loginData')

                setTimeout(() => {
                    navigate('/', { replace: true })
                }, 1500)

                return;
            }

            if (error?.data && typeof error.data === 'object'){
                for (const key in error.data) {
                const messages = error.data[key]
                const message = Array.isArray(messages) ? messages[0] : messages
                toast.error(message)
                }
            }else{
                toast.error("Something went wrong. Please try again.")
            }
        }
    })

    return{isPending,verify}
}

export default useMfaVerification
